import React, { useState } from 'react';
import "../Layout/Layout.css";
import "../Layout/chat.css";

const Chat = () => {
  const [isOpen, setIsOpen] = useState(false);
const phoneNumber = "0909471800"; // Thay bằng số điện thoại Zalo của bạn

  const handleZaloClick = () => {
    // Mở một tab mới dẫn đến Zalo
    window.open(`https://zalo.me/${phoneNumber}`, '_blank', 'noopener,noreferrer');
  };
  return (
    <div className='chat-container'>
      {isOpen && (
        <div >
          <div className="chat-button">
             <img src='/imges/call.png' alt=''></img>
         
          </div>
          <div className="chat-button" onClick={handleZaloClick}>
             <img src='/imges/zalo.png' alt=''></img>
          </div>
        </div>
      )}
      {/* Nút hình tròn */}
      <button onClick={() => setIsOpen(!isOpen)} className="chat-button" >
        {/* {isOpen ? <X size={28} /> : <MessageCircle size={28} />} */}
        {isOpen ? <img src='/imges/dong.png' alt=''></img> :<img src='/imges/tu-van.png' alt=''></img>  }
       

      </button>
      
    </div>
  );
};

export default Chat;